import React from "react";
import Hero from "./components/Hero";
import Navigation from "./components/Navigation";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Projects from "./components/Projects";
import Blogs from "./components/Blogs";
import SayHello from "./components/SayHello";
import Contact from "./components/Contact";
import Aboutme from "./components/Aboutme";
import Footer from "./components/Footer";
import Skills from "./components/Skills";
function App() {
	return (
		<Router>
			<Navigation />
			<Switch>
				<Route exact path="/">
					<Hero />
					<Projects />
					<Skills />
					<Blogs />
					<SayHello />
				</Route>
				<Route exact path="/aboutme">
					<Aboutme />
				</Route>
				<Route exact path="/projects">
					<Projects more={true} />
				</Route>
				<Route exact path="/blogs">
					<Blogs more={true} />
				</Route>
				<Route exact path="/contact">
					<div className="bg-dark" style={{ height: "500px" }}>
						<Contact />
					</div>
				</Route>
			</Switch>
			<Footer />
		</Router>
	);
}

export default App;
